<template>
  <div class="tva-quote-component tva-row">
    <div class="quote-container tva-col-xs-offset-1 tva-col-xs-10 tva-col-md-offset-1 tva-col-md-7">
      <svgicon icon="quote1" height="50" width="50"></svgicon>
      <h5 class="quote">{{content.text}}</h5>
      <div class="author">
        <p v-html="content.author">{{content.author}}</p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["content"]
};
</script>
<style lang="scss" scoped>
@import "../assets/scss/fonts.scss";
@import "../assets/scss/colors.scss";
@import "../assets/scss/bootstrap-grid.scss";
.tva-quote-component {
  .quote-container {
    .svg-icon {
      fill: $eni-yellow;
    }
    h5 {
      margin-top: 10px;
      margin-bottom: 20px;
    }
    .author {
      display: flex;
      justify-content: flex-end;
      width: 100%;
      p {
        font-size: 16px;
        font-weight: 800;
        line-height: 2.38;
        color: $eni-grey;
        position: relative;
        padding-left: 10px;
        font-weight: 400;
        b {
          font-weight: 900;
        }
        &::before {
          content: "";
          height: 20px;
          width: 2px;
          position: absolute;
          top: 9px;
          left: 0;
          background: $eni-yellow;
        }
      }
    }
  }
}
@media (max-width: 1024px) {
  .tva-quote-component {
    .quote-container {
      .svg-icon {
        margin-top: 50px;
      }
      h5 {
        margin-top: 0;
      }
    }
  }
}
@media (max-width: 720px) {
  .tva-quote-component {
    margin: 30px 0;
    .quote-container {
      position: relative;
      .svg-icon {
        margin-top: 0;
        position: absolute;
        top: -5px;
        left: -10px;
        height: 20px !important;
      }
      h5 {
        margin-top: 0;
        &::first-letter {
          padding-left: 40px;
        }
      }
      .author p {
        font-size: 14px;
        line-height: 16px;
        &::before {
          content: "";
          height: 15px;
          top: 0;
        }
      }
      p {
        font-size: 14px;
      }
    }
  }
}
</style>


